import React from 'react';
import { Breadcrumbs, Link, Typography, Paper } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { useLanguage } from '../contexts/LanguageContext';

const BreadcrumbNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLanguage();

  // Don't show breadcrumbs on home page
  if (location.pathname === '/') {
    return null;
  }

  const pathnames = location.pathname.split('/').filter(x => x);

  const getBreadcrumbName = (pathname, index, array) => {
    switch(pathname) {
      case 'chapters':
        return t('menu.chapters');
      case 'verses':
        return t('menu.verses');
      default:
        if (!isNaN(pathname)) {
          const prevPath = array[index - 1];
          if (prevPath === 'chapters') {
            return `${t("menu.chapters")} ${pathname}`
          } else if (prevPath === 'verses') {
            return `${t("menu.verses")} ${pathname}`
          }
        }
        return pathname;
    }
  };

  const generateBreadcrumbLink = (index) => {
    const path = pathnames.slice(0, index + 1);
    return '/' + path.join('/');
  };

  // Modify the path structure for verse URLs
  const getModifiedPathnames = () => {
    return pathnames;
  };

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        mb: 3, 
        mt: 1,
        p: 1.5,
        backgroundColor: 'background.paper',
        borderRadius: 2
      }}
    >
      <Breadcrumbs 
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          '& .MuiBreadcrumbs-ol': {
            flexWrap: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }
        }}
      >
        <Link
          component="button"
          variant="body1"
          onClick={() => navigate('/')}
          color="inherit"
          sx={{ 
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          {t('menu.home')}
        </Link>
        
        {getModifiedPathnames().map((name, index) => {
          const isLast = index === getModifiedPathnames().length - 1;
          const breadcrumbName = getBreadcrumbName(name, index, getModifiedPathnames());
          
          return isLast ? (
            <Typography 
              key={index} 
              color="text.primary"
              sx={{ 
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontWeight: 500
              }}
            >
              {breadcrumbName}
            </Typography>
          ) : (
            <Link
              key={index}
              component="button"
              variant="body1"
              onClick={() => navigate(generateBreadcrumbLink(index))}
              color="inherit"
              sx={{ 
                textDecoration: 'none',
                '&:hover': { textDecoration: 'underline' },
                whiteSpace: 'nowrap'
              }}
            >
              {breadcrumbName}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Paper>
  );
};

export default BreadcrumbNavigation;
